module.exports = __webpack_public_path__ + "static/media/litigio.55107f9b.mp4";